import { ModelBase } from '../abstract/model-base.model';

export interface ImportRowMessage {
    field: string | null;
    type: 'error' | 'warning';
    text: string;
}

export class ImportRow extends ModelBase {
    static override CLASS_NAME: string = 'ImportRow';

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _data!: { [key: string]: any };
    private _matchStrategy!: string;
    private _messages!: ImportRowMessage[];
    private _processingStatus!: string;
    private _rowNumber!: number;

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get data(): { [key: string]: any } {
        return this._data;
    }

    public set data(value: any) {
        this._setValue('_data', value, 'any');
    }

    public get matchStrategy(): string {
        return this._matchStrategy;
    }

    public set matchStrategy(value: any) {
        this._setValue('_matchStrategy', value, 'string');
    }

    public get messages(): ImportRowMessage[] {
        return this._messages;
    }

    public set messages(value: any) {
        this._setValue('_messages', value, 'any');
    }

    public get processingStatus(): string {
        return this._processingStatus;
    }

    public set processingStatus(value: any) {
        this._setValue('_processingStatus', value, 'string');
    }

    public get rowNumber(): number {
        return this._rowNumber;
    }

    public set rowNumber(value: any) {
        this._setValue('_rowNumber', value, 'integer');
    }
}
